(function ($) {
    'use strict';

    $.fn.switchingFalsePage= function () {
        var $self = $(this);
        var $falsePage = $self.find('.js-false-page');
        var $button = $self.find('.js-false-page-button');

        /**
         * удаляем у всех активный класс
         * */
        var removeActiveClass = function () {
            $falsePage.each(function () {
                $(this).removeClass('active');
            });
        };
        /**
         * делаем активной первую страницу
         * */
        var initFirstPage = function () {
            $falsePage.eq(0).addClass('active');
        };

        /**
         * инициализация плагина
         * */
        var init = function () {
            initFirstPage();
            $button.each(function (index) {
                $(this).on('click', function () {
                    removeActiveClass();
                    if (index === 0) {
                        $falsePage.eq(1).addClass('active');
                        return;
                    }
                    $falsePage.eq(0).addClass('active');
                });
            });
        };
        init();
        return this;
    };
    $('.js-false-page-wrapper').each(function () {
        $(this).data('switchingFalsePage', $(this).switchingFalsePage());
    });
})(jQuery);
